import { UTILS } from "utils";

const validateInputs = (modifierGroup, setError=()=>{}, t=()=>{}) => {
    let isValid = true;
    let obj = {
      baseLanguage: {
        name: "",
      },
      isSingleSelection: "",
    };

    if (
      !modifierGroup?.values?.baseLanguage.name ||
      UTILS.hasWhiteSpace(modifierGroup?.values?.baseLanguage?.name)
    ) {
      isValid = false;
      obj.baseLanguage.name = t("Enter Section Name");
      setError(obj);
      return { isValid, obj };
    }

    if (
      !modifierGroup?.values.maximumAllowedSelection ||
      UTILS.hasWhiteSpace(modifierGroup?.values.maximumAllowedSelection)
    ) {
      isValid = false;
      obj.maximumAllowedSelection = t("Enter Maximum Allowed Sections");
      setError(obj);
      return { isValid, obj };
    }
    if (modifierGroup?.values?.maximumAllowedSelection <= 0) {
      isValid = false;
      obj.maximumAllowedSelection = t("Maximum selection value cannot be zero");
      setError(obj);
      return { isValid, obj };
    }
    if (
      !modifierGroup.values?.maximumAllowedSelection ||
      UTILS.hasWhiteSpace(modifierGroup.values.maximumAllowedSelection)
    ) {
      isValid = false;
      obj.maximumAllowedSelection = t("Enter Maximum Allowed Sections");
      setError(obj);
      return { isValid, obj };
    }
    if (modifierGroup?.values?.maximumAllowedSelection <= 0) {
      isValid = false;
      obj.maximumAllowedSelection = t("Maximum selection value cannot be zero");
      setError(obj);
      return { isValid, obj };
    }
    if (
      modifierGroup?.values?.minimumAllowedSelection >
      modifierGroup?.values?.maximumAllowedSelection
    ) {
      isValid = false;
      obj.minimumAllowedSelection = t(
        "Minimum selection value must be than less or equal to maximum selection value"
      );
      setError(obj);
      return { isValid, obj };
    }
    if (modifierGroup.errors.isSingleSelection) {
      if (modifierGroup.values.minimumAllowedSelection > 1) {
        isValid = false;
        obj.minimumAllowedSelection = t(
          "For single selection, minimum allowed selection cannot be greater than 1"
        );
        setError(obj);
        return { isValid, obj };
      }
      setError(obj);
      return { isValid, obj };
    }

    return { isValid, obj };
  };
  
  export {
    validateInputs,
  }